import { TODAY_SCHEDULE_FETCH } from "../../constants";
import { REHYDRATE } from "redux-persist";
import { actionRehydrate } from "@utils";

const initialState = {
  schedules: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return actionRehydrate(state, action.payload, "todaySchedules");
    case TODAY_SCHEDULE_FETCH:
      return {
        schedules: action.payload,
      };

    default:
      return state;
  }
};
